import isEmpty from "lodash.isempty";
import keyBy from "lodash.keyby";
import { makeAutoObservable } from "mobx";
import { enableStaticRendering } from "mobx-react";

import normalizeNavigation from "../shared/helpers/normalizeNavigation/normalizeNavigation";

const isServer = typeof window === "undefined";
enableStaticRendering(isServer);

class NavigationStore {
  additionalFooterNavigation = [];

  topNavigation = [];

  footerLinks = [];

  socialmediaNavigation = [];

  icons = [];

  constructor(initialData) {
    makeAutoObservable(this);
    // Ensure all navigation arrays are actually arrays (defensive check)
    // This prevents .map() errors when data is malformed or during 404/500 prerender
    // Handle both empty initialData (404/500 pages) and malformed data
    this.additionalFooterNavigation = Array.isArray(
      initialData?.additionalFooterNavigation
    )
      ? initialData.additionalFooterNavigation
      : [];
    this.additionalHeaderNavigation = Array.isArray(
      initialData?.additionalHeaderNavigation
    )
      ? initialData.additionalHeaderNavigation
      : [];
    this.countryCodeNavigation = Array.isArray(
      initialData?.countryCodeNavigation
    )
      ? initialData.countryCodeNavigation
      : [];
    this.topNavigation = Array.isArray(initialData?.topNavigation)
      ? normalizeNavigation(initialData.topNavigation)
      : [];
    this.footerLinks = Array.isArray(initialData?.footerLinks)
      ? initialData.footerLinks
      : [];
    this.icons = Array.isArray(initialData?.icons) ? initialData.icons : [];
    this.socialmediaNavigation = Array.isArray(
      initialData?.socialmediaNavigation
    )
      ? initialData.socialmediaNavigation
      : [];
  }

  get isAdditionalFooterNavigationUsed() {
    return !isEmpty(this.additionalFooterNavigation);
  }

  get isAdditionalHeaderNavigationUsed() {
    return !isEmpty(this.additionalHeaderNavigation);
  }

  get isCountryCodeNavigationUsed() {
    return !isEmpty(this.countryCodeNavigation);
  }

  get iconsById() {
    return keyBy(this.icons, "id");
  }
}

export default NavigationStore;
